import { BYTES_PER_MB } from '../../../../utils/formatFileSize';
import { INVOICE_FILE_LIMIT_MB } from './currentSupplierLimits';

const ONLY_PDF_INVOICES = 'Only PDF invoices can be uploaded.';

const isPdf = (file: File) => file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');

export const invoiceFileRefusal = (file: File): string | null => {
  if (!isPdf(file)) return ONLY_PDF_INVOICES;
  if (file.size > INVOICE_FILE_LIMIT_MB * BYTES_PER_MB) return `The file is over ${INVOICE_FILE_LIMIT_MB} MB.`;
  return null;
};
